import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import cloneDeep from 'lodash-es/cloneDeep';

import {ModalComponent} from '../../modal';
import {BlockingError, GroupZoneDescriptor, ZoneDescriptor} from '../form-generator.interfaces';

@Component({
  selector: 'gp-blocking-error-resolution-modal',
  templateUrl: './blocking-error-resolution-modal.component.html',
  styleUrls: ['blocking-error-resolution-modal.component.scss']
})
export class BlockingErrorResolutionModalComponent implements OnInit, OnChanges {

  @Input()
  blockingErrors: BlockingError[] = [];

  @Input()
  zoneDescriptor: ZoneDescriptor;

  @Input()
  groupZoneDescriptor: GroupZoneDescriptor;

  @Output() public onCancelChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() public onBackToEditMode: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('blockingErrorResolutionModal', {static: true})
  public modal: ModalComponent;

  public sanitizedBlockingErrors: BlockingError[] = [];

  constructor() {
  }

  ngOnInit() {
    this.sanitizeErrorMessage();
  }

  public ngOnChanges(changes: any) {
    if (changes.blockingErrors) {
      this.sanitizeErrorMessage();
    }
  }

  public cancelChange() {
    this.onCancelChange.emit(this.zoneDescriptor);
    this.modal.close();
  }

  public backToEditMode() {
    this.onBackToEditMode.emit(this.zoneDescriptor);
    this.modal.close();
  }

  public sanitizeErrorMessage() {
    this.sanitizedBlockingErrors = cloneDeep(this.blockingErrors);
    this.sanitizedBlockingErrors.forEach(error => {
      if (error.errorMessage.zone && error.errorMessage.text.includes('/')) {
        error.errorMessage.text = error.errorMessage.text.split('/').pop();
      }
    });
  }

}
